import toast from "react-hot-toast";
import * as api from "../Api";
import { errorMessage, loadFailed } from "../utils/errorMessage";

// create a  new asset
export const getDisposedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getDisposedAsset();
    dispatch({ type: "GET_ALL_DISPOSED", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};

export const disposeAsset = (postData, id) => async (dispatch) => {
  const savingId = toast.loading("Disposing asset...");
  try {
    const { data } = await api.disposeAsset(postData, id);
    dispatch({ type: "DISPOSE_ASSET", payload: data });
    toast.remove(savingId);
    toast.success("Asset disposed");
    return true;
  } catch (error) {
    toast.remove(savingId);
    toast.error(errorMessage(error, "Failed to dispose asset"));
    return false;
  }
};
